import { OnboardingAgent } from './onboardingAgent.types.ts';
import { mockOnboardingAgent } from './mockOnboardingAgent.ts';
import { realOnboardingAgent } from './realOnboardingAgent.ts';

const USE_REAL_AGENT = false;

export const onboardingAgent: OnboardingAgent = USE_REAL_AGENT 
  ? realOnboardingAgent 
  : mockOnboardingAgent;

export * from './onboardingAgent.types.ts';
